import log from "loglevel";
import update from "immutability-helper";
import { Map } from "immutable";
import { isType } from "typescript-fsa";

import { isFailedResponseUnauthenticatedNotLogin } from "@api/actions";
import { logout } from "@auth/actions";
import {
    DspsInternalState as State,
    Dsp,
    DspsNormalisedEntities,
} from "../models";
import * as actions from "../actions";

// Intialise state to the browser language.
const getInitialState = () => ({
    entities: {
        dsps: Map<number, Dsp>(),
    },
} as State);

function reduce(state: State = getInitialState(), action: actions.DspsAction): State {
    // State should never be null...
    if (state === null) {
        log.warn("dsps state setting to null, resetting to initialState.");
        state = {} as State;
        state = update(state, { $set: getInitialState() });
    }

    if (isType(action, actions.dspsIndexSuccess)) {
        // Successful dspsIndex
        return mergeEntities(state, action.payload.entities);
    }
    else if (isType(action, logout) || isFailedResponseUnauthenticatedNotLogin(action)) {
        // Clear the state on logout.
        return update(state, { $set: getInitialState() });
    }
    // Otherwise we do nothing
    return state;
}

function mergeEntities(state: State, entities: DspsNormalisedEntities): State {
    // Set up the new state
    const newState = {
        entities: update(state.entities, {}),
    } as State;

    // Merge each map.
    newState.entities = state.entities;
    const { dsps } = entities;
    if (dsps != null) {
        newState.entities = update(newState.entities, {
            dsps: { $merge: state.entities.dsps.merge(dsps) },
        });
    }

    return update(state, {
        entities: { $merge: newState.entities },
    });
}

export { reduce as dsps, getInitialState };
